<template>
  <div class="animated fadeIn py3">
    <div class="clearfix gibson px3 mb2">
      <!-- <div class="col-12 px0">
        <div class="clearfix border muted-border p2 px3 mb2 shadow">
          <div class="col-12 px0 pt3">
            <div class="flex justify-start mb2" style="height:80px;">
              <div class="mintgreen-background darkblue flex flex-column justify-center items-center" style="height:inherit;line-height:80px;width:80px;">
                <p class="gibson m0 p0 semi-bold" style="font-size:48px;height:inherit;line-height:80px;">
                  5
                </p>
              </div>
              <div style="height:inherit;">
                <p class="h4 darkblue mx2 mb0 p0">
                  nye
                  <br>
                  anbefalinger
                </p>
              </div>
            </div>
            <p class="h5 regular darkblue line-height-golden mb3">
              Vi oplever at anbefalinger af håndværkernes udførte arbejde i stigende grad spiller en rolle, når bygherre skal vælge håndværkere.
            </p>
            <p class="h5 regular darkblue line-height-golden mb3">
              Håndværker.dk gør det nu muligt for dig at øge dine chancer for succes ved at lade dine kunder, som du har løst opgaver for uden om vores system, anbefale dit arbejde. Alt du skal gøre er at indtaste din kundes navn og e-mailadresse og klikke på linket.
            </p>
            <collectreviews></collectreviews>
          </div>
        </div>
      </div> -->
      <div class="col-12 px0">
        <div class="clearfix border muted-border p2 shadow">
          <div class="col-12 px0 mt3">
            <haandvaerker></haandvaerker>
            <p class="h4 semi-bold line-height-2 mt3 mb2 px2">
              Få et anbefalingsbanner på din hjemmeside og få flere fordele
            </p>
            <p class="h5 regular darkblue line-height-golden mb3 px2">
              Dine kunder får mere tryghed omkring dig, når de kan se andre kunder også er tilfredse <br />
              Brug dine tilfredse kunder til at tiltrække nye <br />
              Bannerne kan hjælpe dig til at blive placeret bedre på Google <br /><br />
              Sådan får du dit anbefalingsbanner på din egen hjemmeside. <br />
              <ul class="list-reset my2 px0" style="list-style-type: square;list-style-position: inside;">
                <li class="px2 my1 h5 regular line-height-golden">Tryk på den grønne knap herunder</li>
                <li class="px2 my1 h5 regular line-height-golden">Højreklik på linket og send det til din webmaster(den person som har lavet hjemmesiden)</li>
                <li class="px2 my1 h5 regular line-height-golden">Bed din webmaster om at indsætte dit nye anbefalingsbanner, der hvor du mener det skal sidde.</li>
              </ul>
            </p>
          </div>
        </div>
        <div class="clearfix my2" v-if="haaId !== '0'">
          <div class="col-12 mb2 px0">
            <div class="border muted-border p2 shadow">
              <div class="clearfix px0">
                <div class="col-12 px2">
                  <p class="h4 mt3 semi-bold line-height-2 mt3 mb2">Banner med anbefalinger</p>
                  <p class="h5 regular darkblue line-height-golden">
                    Du kan indsætte dette banner som viser, hvor mange anbefalinger du har samt dit gennemsnit.
                    <br />
                    Husk : dine kunder ønsker tryghed i rejsen når de skal finde en lokal håndværker.
                  </p>
                </div>
                <div class="col-12 px0">
                  <b-collapse visible id="collapse5">
                    <ratingWidget :items="items" :ratingwidget="ratingwidget"></ratingWidget>
                  </b-collapse>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 mb2 px0">
            <div class="border muted-border p2 shadow">
              <div class="clearfix px0">
                <div class="col-12 px2">
                  <p class="h4 mt3 semi-bold line-height-2 my2">Banner med udtalelser fra kunder</p>
                  <p class="h5 regular darkblue line-height-golden">
                    Du har også mulighed for at indsætte dette banner, som viser mere tekst fra dine tilfredse kunder.
                    <br />
                    Du kan have begge bannere med på din hjemmeside, for at styrke troværdigheden yderligere.
                  </p>
                </div>
                <div class="col-12 p2">
                  <b-collapse visible id="collapse6" class="mt2">
                    <commentWidget :items="items" :commentwidget="commentwidget"  ></commentWidget>
                  </b-collapse>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <updatebitrixpackagepermission   ref="updatebitrixpackagepermission"></updatebitrixpackagepermission>
    </div>
  </div>
</template>
<script>
import reviews from './Reviews'
import collectreviews from './CollectReview'
import Haandvaerker from './haandvaerker'
import updatebitrixpackagepermission from '../../components/updatebitrixpackagepermission'
import ratingWidget from './ratingWidget'
import commentWidget from './commentWidget'
export default {
  name: 'anbefalinger',
  components: {
    Haandvaerker,
    ratingWidget,
    commentWidget,
    reviews,
    collectreviews,
    updatebitrixpackagepermission
  },
  data () {
    return {
      myHTML: '',
      ratingwidget: '',
      commentwidget: '',
      show: false,
      label: 'Loading...',
      overlay: 1,
      salesPerson: '',
      haaId: '',
      items: [],
      images: []
    }
  },
  created () {
    this.Reload()
  },
  methods: {
    Reload () {
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var data = {operation: 'oversigt_partner_haa', salesPerson: this.salesPerson, levid: this.haaId}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            this.items = res
            this.ratingwidget = res.ratingwidget
            this.commentwidget = res.commentwidget
          },
          response => {
            alert('error')
          }
        )
    }
  }
}
</script>


// WEBPACK FOOTER //
// Anbefalinger.vue?00f12742